module.exports = __webpack_public_path__ + "img/icon3.906b1841.png";